import axios from "axios";
import config from "./config";

const BASE_URL = config.baseApi;
console.log("🚀 ~ BASE_URL:", BASE_URL);
const carMeetStorageString = localStorage.getItem("social-storage");
const carMeetStorage = JSON.parse(carMeetStorageString);

// const ServerCall = () => {
const customAxios = axios.create({
  baseURL: BASE_URL,
});

const requestHandler = (request) => {
  if (carMeetStorage && carMeetStorage.token) {
    const token = carMeetStorage && carMeetStorage.token;
    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
};

const responseHandler = (response) => {
  if (response.status === 401 || response.status === 403) {
    window.location = "/";
    localStorage.removeItem(carMeetStorage.token);
  }
  return response;
};

const requestErrorHandler = (error) => {
  return Promise.reject(error);
};

const responseErrorHandler = (error) => {
  if (error.response) {
    if (error.response.status === 401 || error.response.status === 403) {
      localStorage.removeItem("token");
      localStorage.clear();

      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
};

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => requestErrorHandler(error)
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  responseErrorHandler
);
export default customAxios;
// };

// export default ServerCall;
